import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export interface FormValues {
  name: string;
  category: string;
  description: string;
  sftpIp: string;
  sftpUser: string;
  sftpPassword: string;
  sftpPath: string;
}

export const defaultValues: FormValues = {
  name: '',
  category: '',
  description: '',
  sftpIp: '',
  sftpUser: '',
  sftpPassword: '',
  sftpPath: ''
};

function setSchema() {
  return yup.object({
    name: yup.string().concat(yup.string().required('Name is required').min(1, 'Name cannot be empty')),
    category: yup.string().concat(yup.string().required('Category is required')),
    description: yup.string(),
    sftpIp: yup
      .string()
      .required('SFTP IP is required')
      .matches(
        /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(:\d{1,5})?$/,
        'Please enter a valid IPv4 address.'
      ),
    sftpUser: yup.string().concat(yup.string().required('User Name is required.').min(1, 'User Name cannot be empty.')),
    sftpPassword: yup.string().concat(yup.string().required('Password is required.').min(1, 'Password cannot be empty')),
    sftpPath: yup.string().concat(yup.string().required('SFTP Path is required').min(1, 'SFTP Path cannot be empty'))
  });
}

export function useCnisEndpointForm(initialValues?: FormValues) {
  const schema = setSchema();
  return useForm({
    mode: 'onSubmit',
    resolver: yupResolver(schema),
    defaultValues: { ...defaultValues, ...initialValues }
  });
}
